import React from "react"
import styled from "styled-components"
import Button from "@irati/ui/src/Button"
import idHelper from "@irati/utils/id"
import FormattedMessage from "@irati/utils/lang"

// Still bad UI, we'll work on this again, but better than what we have now.
const Floating = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: block;
  z-index: 999;
  max-width: 690px;
  padding: 8px;
  background-color: ${({theme}) => theme.colors.greys.white};
  box-shadow: ${({theme}) => theme.shadows.mid};
  text-align: center;
`

interface Props {
  onClick: () => any
}

const DealMobileContinue: React.FC<Props> = ({onClick, ...props}) => {
  const id = idHelper("mobile-continue", {props})
  return (
    <Floating>
      <Button id={id} onClick={onClick} primary large full>
        <FormattedMessage id="perks.containers.dealInfo.continue" />
      </Button>
    </Floating>
  )
}

export default DealMobileContinue
